export const ENV = process.env.REACT_APP_ENV ?? "development";

export const STATIC_ASSETS_BUCKET_PREFIX =
  process.env.REACT_APP_STATIC_ASSETS_BUCKET_PREFIX ?? "";

export const DOMAIN_NAME =
  process.env.REACT_APP_DOC_APP_DOMAIN_NAME ?? "mekidoc.cl";

// Replace is needed on production (the api url is different and contains the domain)
export const BASE_URL =
  process.env.REACT_APP_API_URL?.replace(DOMAIN_NAME, "") ?? "";

export const PATIENT_APP_URL =
  process.env.REACT_APP_PATIENT_APP_URL ?? "https://paciente.mekidoc.cl";

export const MEKIDOC_SUPPORT_EMAIL =
  process.env.REACT_APP_MEKIDOC_SUPPORT_EMAIL ?? "";
if (!MEKIDOC_SUPPORT_EMAIL) {
  throw new Error("MEKIDOC_SUPPORT_EMAIL is not set");
}

export const MEKIDOC_SUPPORT_PHONE =
  process.env.REACT_APP_MEKIDOC_SUPPORT_PHONE ?? "";
if (!MEKIDOC_SUPPORT_PHONE) {
  throw new Error("MEKIDOC_SUPPORT_PHONE is not set");
}

export const MEKIDOC_GA4_TRACKING_ID =
  process.env.REACT_APP_MEKIDOC_GA4_TRACKING_ID ?? "";

export const MEKIDOC_GOOGLE_ADS_ID =
  process.env.REACT_APP_MEKIDOC_GOOGLE_ADS_ID ?? "";
export const DOCTOR_REGISTRATION_CONVERSION_ID =
  process.env.REACT_APP_DOCTOR_REGISTRATION_CONVERSION_ID ?? "";

export const DIC_APP_URL = process.env.REACT_APP_DIC_URL ?? "";
export const DIC_API_KEY = process.env.REACT_APP_DIC_API_KEY ?? "";

// Meki
export const MEKI_REST_API_URL =
  process.env.REACT_APP_MEKI_REST_API_URL ?? "https://rest.farmaciameki.cl";

// MeiliSearch
export const MEILI_SEARCH_HOST =
  process.env.REACT_APP_MEILI_SEARCH_HOST ?? "https://search.farmaciameki.cl";

export const MEILI_SEARCH_DEFAULT_API_KEY =
  process.env.REACT_APP_MEILI_SEARCH_DEFAULT_API_KEY ?? "";

// Clinical History API
export const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL ?? "";
